import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { xpoAuthCanMatch } from '@xpo-ltl/ngx-auth';
import { AppRoutes } from './enums/app-routes.enum';
import { AuthRedirectComponent } from './shared/components/auth-redirect/auth-redirect.component';
import { NotAuthorizedComponent } from './shared/components/not-authorized/not-authorized.component';

const routerDefinitions: Routes = [
  {
    path: AppRoutes.NOT_AUTHORIZED_PAGE,
    component: NotAuthorizedComponent,
    canMatch: [xpoAuthCanMatch()],
  },
  // ADD ANY NEW ROUTE / PAGE HERE
  {
    // Every route nested here requires sign-in: canMatch on this wrapper runs before any
    // child route (including its lazy chunk) is matched, so one guard covers them all.
    path: '',
    canMatch: [xpoAuthCanMatch()],
    children: [
      {
        path: AppRoutes.DYNAMIC_RULE,
        loadChildren: () => import('./dynamic-rule/dynamic-rule.module').then((m) => m.DynamicRuleModule),
      },
      {
        path: AppRoutes.CUSTOMER_EXCLUDE,
        loadChildren: () => import('./customer-exclude/customer-exclude.module').then((m) => m.CustomerExcludeModule),
      },
      {
        path: AppRoutes.RATE_QUOTE,
        loadChildren: () => import('./rate-quote/rate-quote.module').then((m) => m.RateQuoteModule),
      },
      {
        path: AppRoutes.DYNAMIC_PRICING,
        loadChildren: () => import('./dp-dashboard/dp-dashboard.module').then((m) => m.DpDashboardModule),
      },
      {
        path: AppRoutes.CUSTOMER_GROUP,
        loadChildren: () => import('./customer-group/customer-group.module').then((m) => m.CustomerGroupModule),
      },
      {
        path: AppRoutes.SHIPMENT_VISIBILITY,
        loadChildren: () =>
          import('./shipment-visibility/shipment-visibility.module').then((m) => m.ShipmentVisibilityModule),
      },
      {
        path: AppRoutes.ACCESSORIAL_CHARGE,
        loadChildren: () =>
          import('./accessorial-charge/accessorial-charge.module').then((m) => m.AccessorialChargeModule),
      },
      {
        path: AppRoutes.ABSOLUTE_MINIMUM_CHARGE,
        loadChildren: () =>
          import('./absolute-minimum-charge/absolute-minimum-charge.module').then((m) => m.AbsoluteMinimumChargeModule),
      },
      {
        path: AppRoutes.RFP,
        loadChildren: () => import('./dpt/dpt.module').then((m) => m.DptModule),
      },
      {
        path: AppRoutes.PRICING_CODES,
        loadChildren: () => import('./pricing-codes/pricing-codes.module').then((m) => m.PricingCodesModule),
      },
      {
        path: AppRoutes.DPT_DISCOUNT,
        loadChildren: () => import('./dpt-discount/dpt-discount.module').then((m) => m.DptDiscountModule),
      },
      {
        path: '**',
        component: AuthRedirectComponent,
      },
    ],
  },
  {
    path: '**',
    component: AuthRedirectComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routerDefinitions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
